module.exports = __webpack_public_path__ + "img/KarpinPos.cda10a69.webp";